import { render } from "./SensorIcon.vue?vue&type=template&id=210d2b36"
import script from "./SensorIcon.vue?vue&type=script&lang=js"
export * from "./SensorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__